import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { LLM_MODEL_MAPPING } from "../../../utils/constant";

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const sortedPayload = payload?.sort((a, b) => {
      return b["value"] - a["value"];
    });
    return (
      <div style={{ display: 'flex', flexDirection: 'column' }} className="custom-tooltip-container">
        {/* <p style={{ margin: 0, fontWeight: "bold", paddingBottom: "4px" }}>
          {label}
        </p> */}
        <ul style={{ paddingLeft: 10, margin: 0 }}>
          {sortedPayload?.map((obj, index) => {
            return (
              <li key={index}>
                {obj?.name} : {obj?.value}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  return null;
};

const ReLineChart = ({ data }) => {
  const colors = [
    "#8884d8",
    "#82ca9d",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#A28ADF",
    "#F44E54",
    "#2A9D8F",
    "#E76F51",
    "#264653",
  ];

  const brands =
    data && data.length !== 0
      ? [
        ...new Set(
          data.flatMap((obj) =>
            Object.keys(obj).filter((key) => key !== "date" && key !== "llmName")
          )
        ),
      ]
      : [];

  return (
    <div style={{ height: "380px", width: "100%" }}>
      {/* <h5>Time-Series Chart</h5> */}
      <ResponsiveContainer
        width="100%"
        height="100%"
        style={{ backgroundColor: "white" }}
      >
        <LineChart data={data} margin={{ right: 5 }}>
          <CartesianGrid vertical={false} />

          <XAxis
            dataKey="date"
            interval={0}
            angle={-45}
            textAnchor="end"

            tick={({ x, y, payload, index }) => {
              const fullDate = payload.value; // original full date
              let shortDate = fullDate;
              const parts = fullDate.split("-");
              shortDate = `${parts[0]}-${parts[1]}`;

              // Get the LLM name from the data point
              const dataPoint = data[index] || {};
              const llmName = dataPoint.llmName || "";

              return (
                <g transform={`translate(${x},${y})`}>
                  <text
                    x={0}
                    y={0}
                    dy={25}
                    textAnchor="end"
                    height={80}
                    style={{ fontSize: 11 }}
                  >
                    <title>{`${fullDate} - ${LLM_MODEL_MAPPING?.[llmName] || llmName}`}</title>
                    <tspan x={0} dy="8">{shortDate}</tspan>
                    {llmName && <tspan x={0} dy="12" style={{ fontSize: 9, fill: "#666" }}>{ LLM_MODEL_MAPPING?.[llmName] || llmName}</tspan>}
                  </text>
                </g>
              );
            }}
          />


          {/* <XAxis
            dataKey="date"
            axisLine={{ stroke: "white" }}
            tickLine={false}
            tickMargin={0}
            // interval={0} // force show all ticks
            // tick={{ fontSize: 10 }} // smaller font so they fit
            // angle={-15} // rotate ticks for readability
            // textAnchor="end"

          /> */}
          <YAxis
            domain={[0, 100]} // Set the domain from 0 to 100
            tickCount={11} // Number of ticks (0, 10, 20, ... 100)
            axisLine={{ stroke: "white" }}
            tickLine={false}
            tickMargin={12}
            label={{
              value: "Brand Index Score",
              angle: -90, // Rotates the label to be vertical
              position: "insideLeft", // Adjust position relative to the axis
              // fill: "black", // Label text color
              fontSize: 14, // Label text size
              fontFamily: "Roboto Flex, sans-serif", // Label font style
              dy: 50, // Adjust vertical spacing
            }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend wrapperStyle={{ paddingBottom: 20 }} verticalAlign="top" />
          {brands &&
            brands.length > 0 &&
            brands?.map((brand, index) => (
              <Line
                key={brand}
                type="monotone"
                dataKey={brand}
                stroke={colors[index % colors.length]}
                fill={colors[index % colors.length]}
              />
            ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ReLineChart;
